/* eslint-disable react/forbid-prop-types,react/require-default-props,react/prop-types */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Bind } from 'lodash-decorators';
import ds from 'designsystem';
import PropTypes from 'prop-types';
import BurgerIcon from 'blocks/BurgerIcon';
import Logo from 'blocks/Navigation/Logo';
import MenuButtons from 'blocks/Navigation/MenuButtons';
import Buttons from 'blocks/Navigation/Buttons';
import MainNavigation from 'blocks/Navigation/MainNavigation';
import { reaction } from 'mobx';
import { MOBILE_NAV_TRANSITION_SPEED } from 'common/consts/navigation';
import { getNumbers } from 'common/methods/string';
import BurgerWrapper from './BurgerWrapper';
import MobileNavContainer from './MobileNavContainer';
import MobileNavSections from './MobileNavSections';
import MobileNavSection from './MobileNavSection';
import MobileMenuItem from './MobileMenuItem';
import MobileNavTitle from './MobileNavTitle';
import Languages from '../Languages';

@inject('productsStore', 'windowStore')
@observer
class MobileNavigation extends Component {
  constructor(props) {
    super(props);
    this.mobileNavRef = React.createRef();
  }

  componentDidMount() {
    const { navigationStore } = this.props;
    this.onMenuToggle();
    this.disposeMenuHideReaction = reaction(() => navigationStore.isMobileNavOpen,
      () => this.onMenuToggle());
  }

  componentWillUnmount() {
    this.disposeMenuHideReaction();
  }

  @Bind
  onMenuToggle() {
    const { navigationStore } = this.props;
    if (this.mobileNavRef.current && !navigationStore.isMobileNavOpen) {
      this.hideTimeout = setTimeout(() => {
        if (this.mobileNavRef.current) {
          this.mobileNavRef.current.style.opacity = '0';
        }
        clearTimeout(this.hideTimeout);
      }, getNumbers(MOBILE_NAV_TRANSITION_SPEED));
    } else {
      clearTimeout(this.hideTimeout);
      this.mobileNavRef.current.style.opacity = '1';
    }
  }

  @Bind
  toggleMenu() {
    const { navigationStore } = this.props;
    if (navigationStore.isMobileNavOpen) {
      navigationStore.closeMobileNav();
    } else {
      navigationStore.openMobileNav();
    }
  }

  render() {
    const {
      navigationStore,
      parsedStructure,
      productsStore,
      windowStore,
    } = this.props;

    return (
      <React.Fragment>
        <BurgerWrapper onClick={this.toggleMenu}>
          <BurgerIcon active={navigationStore.isMobileNavOpen} color={ds.brand('product')} />
        </BurgerWrapper>

        <MobileNavContainer
          innerRef={this.mobileNavRef}
          hidden={!navigationStore.isMobileNavOpen}
          scrollRefId="nav-parent"
        >
          <Logo alignSelf="flex-start" />

          <MobileNavSections>
            <MobileNavSection isPortraitOrientation={windowStore.isPortraitOrientation}>
              {productsStore.currentProduct && productsStore.currentProduct.name ? (
                <MobileNavTitle>
                  { `${productsStore.currentProduct.name}:` }
                </MobileNavTitle>
              ) : ''}
              <MenuButtons
                parsedStructure={parsedStructure}
                buttonComponent={(
                  <MobileMenuItem
                    itemClick={() => navigationStore.closeMobileNav()}
                  />
                )}
              />
            </MobileNavSection>

            <MobileNavSection isPortraitOrientation={windowStore.isPortraitOrientation}>
              <MainNavigation
                itemClick={() => navigationStore.closeMobileNav()}
                renderLogo={false}
                renderButtons={false}
              />
            </MobileNavSection>

            <MobileNavSection isPortraitOrientation={windowStore.isPortraitOrientation}>
              <Languages />
            </MobileNavSection>

          </MobileNavSections>

          <Buttons onItemClick={() => navigationStore.closeMobileNav()} />

        </MobileNavContainer>

        <Logo absolute />
      </React.Fragment>
    );
  }
}
MobileNavigation.propTypes = {
  navigationStore: PropTypes.object,
  parsedStructure: PropTypes.array,
};
MobileNavigation.defaultProps = {
  parsedStructure: [],
};
export default MobileNavigation;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MobileNavigation/index.jsx